import React, { useEffect, useState } from 'react';
import { GridComponent } from 'src/components/common/GridComponent';
import MenuItemComponent, { MenuType } from 'src/components/common/MenuItemComponent';
import { StackComponent } from 'src/components/common/StackComponent';
import { setUserAccessData } from 'src/store/Site';
import { useAppDispatch } from 'src/store/hooks';
import { ITabLevelHierarchy } from 'src/types/TabsType';
import { ButtonComponent } from '../common/ButtonComponent';
import '../common/DashboardNavbar.scss';
import { useSearchHierarchy } from './useSearchHierarchy';
import { CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

export interface resData {
  name: string;
  role: string;
  sponsor_name: string;
}

export interface IMenu {
  label: string;
  value: string;
  options: string[];
  resData: resData[];
  menuType: MenuType;
}

export interface IMenus {
  sponsor: IMenu;
  study: IMenu;
  country: IMenu;
  site: IMenu;
  tabHierarchyLevels: ITabLevelHierarchy;
}

export interface IMenuAction {
  menu: IMenus;
  onChange: (item: string, type: MenuType) => void;
}

export interface ISelected {
  sponsor: string;
  study: string;
  country: string;
  site: string;
}

export interface ISearchHierarchy {
  getSelectedData?: (menu: ISelected) => void;
  getLoadingState?: (isLoading: boolean) => void;
}

export const SearchHierarchy: React.FC<ISearchHierarchy> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [isFirstRender, setIsFirstRender] = useState(false);
  const { onChange, sponsorStudyCountrySite, loading, hierarchyVisibility } = useSearchHierarchy();

  useEffect(() => {
    if (
      sponsorStudyCountrySite['study']?.value &&
      sponsorStudyCountrySite['site']?.value &&
      sponsorStudyCountrySite['country']?.value
    ) {
      setIsFirstRender(true);
    }
  }, [sponsorStudyCountrySite]);
  dispatch(setUserAccessData(sponsorStudyCountrySite));
  return (
    <div>
      {!isFirstRender && loading ? (
        <CircularProgress size="1rem" style={{ position: 'relative', left: '5px' }} />
      ) : (
        <GridComponent container className="study-hierarchy-menu">
          <GridComponent md={12}>
            <div className="study-hierarchy-menu">
              <StackComponent direction="row" spacing={2}>
                <ButtonComponent variant="contained">
                  Sponsor: &nbsp; <span>{sponsorStudyCountrySite.sponsor.value}</span>
                </ButtonComponent>
                {Object.entries(sponsorStudyCountrySite).map(menu =>
                  hierarchyVisibility?.length > 0 ? (
                    menu[0] != 'sponsor' &&
                    menu[0] != 'tabHierarchyLevels' &&
                    hierarchyVisibility?.includes(menu[0]) ? (
                      <MenuItemComponent key={menu[0]} {...menu[1]} onChange={onChange} />
                    ) : (
                      ''
                    )
                  ) : menu[0] != 'sponsor' &&
                    menu[0] != 'tabHierarchyLevels' &&
                    (location.pathname === '/visit-schedule' || JSON.stringify(hierarchyVisibility) === '{}') ? (
                    <MenuItemComponent key={menu[0]} {...menu[1]} onChange={onChange} />
                  ) : (
                    ''
                  )
                )}
              </StackComponent>
            </div>
          </GridComponent>
        </GridComponent>
      )}
    </div>
  );
};
